module.exports = __webpack_public_path__ + "img/staliz-bg-menu.svg?426f4b92cb5932e098084fd8d0a4fd5f";